import { jsx } from 'react/jsx-runtime';
import { forwardRef, useId, useMemo } from 'react';
import { useInputChange } from '../hooks/use-input-change.js';
import { RadioContext } from './radio-context.js';

/**
 * @see https://fpl.figma.design/components/inputs/radio/#radio-group
 */
const Root = forwardRef(function Root({ autofocus = false, onChange: onChangeIn, recordingKey, readonly, ...props }, ref) {
    const name = useId();
    const inputProps = useInputChange({
        disabled: readonly,
        onChange: onChangeIn,
        recordingKey,
        readonly,
        ...props,
    });
    const { onChange } = inputProps;
    const { value } = props;
    const contextValue = useMemo(() => ({
        name,
        value: value ?? '',
        onChange,
        readonlyGroup: readonly,
        autofocus,
    }), [name, onChange, value, readonly, autofocus]);
    return (jsx("fieldset", { "data-fpl-component": "primitive", ...props, ref: ref, role: "radiogroup", "aria-readonly": readonly || undefined, "aria-disabled": readonly || undefined, "aria-labelledby": props['aria-labelledby'] ?? undefined, children: jsx(RadioContext.Provider, { value: contextValue, children: props.children }) }));
});
Root.displayName = 'RadioPrimitive.Root';

export { Root };
//# sourceMappingURL=radio-group.js.map
